import type { Operation } from "fast-json-patch";

export default function useApplicationPatch() {
  function filterApplicationPatches(patches: Operation[]) {
    if (patches.length === 0) {
      return patches;
    }
    const validApplicationPaths = [
      "programTypeId",
      "loanId",
      "statusReasonId",
      "metadata",
      "schoolConfiguration",
      "applicationRefiSchool",
      "student",
    ];

    const filteredApplicationPatches = patches.filter(patch =>
      validApplicationPaths.some(validPath => patch?.path?.startsWith(`/${validPath}`)),
    );

    return filteredApplicationPatches;
  }
  return { filterApplicationPatches };
}
